import { useContext, useState } from 'react';
import { usePagination, useWP } from '../../../hooks/WPHooks';
import { PaginationFetch, SearchHookReturn } from './SearchHook';
import { AppContext } from '../../../state/AppContextProvider';
import { DirectoryFilterObject, WP_Tag } from '../../../model/tags/tags';
import { WP_DirUser, WP_HouseTerm } from '../../../model/models';
import { ModelsService } from '../../../services/ModelsService';
import { WP_FetchPage } from '../../../services/WPService';

export const useSearchUsers: () => SearchHookReturn = () => {
  const { wp } = useWP();

  const { state } = useContext(AppContext);

  const [filter, setFilter] = useState<DirectoryFilterObject>({});

  const changeFilterByUrl = (
    houseValue: WP_HouseTerm | null,
    otherTagsValue: string | null
  ) => {
    const newFilter = {
      ...filter,
      house: houseValue,
      otherTags: otherTagsValue,
    };
    setFilter(newFilter);
  };

  const changeFilter = (tagsList: {
    [tagType: string]: WP_Tag | WP_HouseTerm | string | null;
  }) => {
    setFilter(tagsList);
  };

  const resetFilter = () => {
    setFilter({});
  };

  // don't display users without name and photo
  const userFilter = (u: WP_DirUser) =>
    ModelsService.userDirectoryFilter(u, state.user?.id || 0);

  const buildOtherParams = () => {
    let otherParams = {};

    const filterWithoutHouseAndOtherTags: DirectoryFilterObject = {
      ...filter,
      house: null,
      otherTags: null,
    };

    const arrayFilter: Array<WP_Tag> = Object.values(
      filterWithoutHouseAndOtherTags
    ).filter((value) => value !== null);

    if (arrayFilter.length > 0 || filter.otherTags) {
      let listTagId: string = '';
      arrayFilter.forEach((item) => {
        if (listTagId === '') {
          listTagId = listTagId + item.id;
        } else {
          listTagId = listTagId + ',' + item.id;
        }
      });

      if (filter.otherTags) {
        if (listTagId !== '') {
          listTagId = listTagId + ',';
        }
        listTagId = listTagId + filter.otherTags;
      }

      const filterTag: string = 'filter[tax-tag]';

      otherParams[filterTag] = listTagId;
    }

    if (filter.house) {
      const filterHouse: string = 'filter[tax-house]';
      otherParams[filterHouse] = filter.house.id;
    }

    return otherParams;
  };

  const fetch: WP_FetchPage<WP_DirUser> = (
    pagination,
    { keywords, category }
  ) => {
    let otherParams = buildOtherParams();

    const response = wp
      .searchUsers<WP_DirUser>(pagination, keywords, otherParams)
      .then((r) => {
        r.items = r.items.filter(userFilter);
        return r;
      });

    return response;
  };

  const {
    items,
    fetchMore,
    hasMoreItems,
    loading,
    reset,
    isReset,
    page,
    totalPage,
  } = usePagination(fetch);

  return {
    reset: reset,
    isReset: isReset,
    search: fetchMore as PaginationFetch,
    hasMore: hasMoreItems,
    loading: loading,
    page: page,
    totalPage: totalPage,
    items: items,
    filter: filter,
    changeFilter: changeFilter,
    resetFilter: resetFilter,
    changeFilterByUrl: changeFilterByUrl,
  };
};
